export const CUSTOMER_SERVICE_CUSTOMER_POLICY_PREFIX = 'CustomerService.Customer.';

export type OrganizationSettingsPermissionRoute = {
  permissionName?: string | string[];
  name?: string | string[];
};

export const getOrganizationSettingsPermissionKeys = (
  route: OrganizationSettingsPermissionRoute,
): string[] => {
  const permissionKey = route.permissionName ?? route.name;
  if (permissionKey == null || permissionKey === '') return [];
  return Array.isArray(permissionKey) ? permissionKey : [permissionKey];
};

export const hasOrganizationSettingsPermission = (
  route: OrganizationSettingsPermissionRoute,
  grantedPolicies: Record<string, boolean> | null | undefined,
  userRouteList: string[],
): boolean => {
  const permissionKeys = getOrganizationSettingsPermissionKeys(route);
  if (permissionKeys.length === 0) return false;

  return permissionKeys.some((permissionKey) => {
    const policyKey = `${CUSTOMER_SERVICE_CUSTOMER_POLICY_PREFIX}${permissionKey}`;
    if (grantedPolicies?.[policyKey] === true) {
      return true;
    }

    return userRouteList.includes(permissionKey);
  });
};
